import { render, staticRenderFns } from "./LoginTitle.vue?vue&type=template&id=5c5c4882&scoped=true"
import script from "./LoginTitle.vue?vue&type=script&lang=js"
export * from "./LoginTitle.vue?vue&type=script&lang=js"
import style0 from "./LoginTitle.vue?vue&type=style&index=0&id=5c5c4882&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5c4882",
  null
  
)

export default component.exports